import React, { useState } from 'react';
import WriteableReviewPresenter from './WriteableReviewPresenter';

import { useFetchQuotationUserRfqAvailableReviewsQuery } from '@generated/graphql';
import { useSelector } from '@store';

const WriteableReviewContainer = () => {
  const id = useSelector((state) => state.client.id);
  const [visibleCount, setVisibleCount] = useState(4);

  const { data, loading } = useFetchQuotationUserRfqAvailableReviewsQuery({
    variables: {
      input: {
        quotationUserId: id
      }
    },
    skip: !id
  });

  const writeableRfqs =
    data?.fetchQuotationUserRfqAvailableReviews.data?.rfqs ?? [];

  const reviewsTotalCount = writeableRfqs.length;

  const handleVisibleCount = () => {
    return setVisibleCount((prev) => {
      if (prev + 4 >= reviewsTotalCount) {
        return reviewsTotalCount;
      }

      return prev + 4;
    });
  };

  return (
    <WriteableReviewPresenter
      loading={loading}
      writeableRfqs={writeableRfqs}
      visibleCount={visibleCount}
      handleVisibleCount={handleVisibleCount}
    />
  );
};

export default WriteableReviewContainer;